<app-header></app-header>
<app-menu></app-menu>

<nx-multi-stepper [linear]="true" currentStepLabel="Step" class="nx-margin-top-m">
  <ng-container *ngFor="let step of multiSteps">
    <nx-step [label]="step.name" [completed]="step.completed">
    </nx-step>
  </ng-container>
</nx-multi-stepper>

<router-outlet #outlet="outlet"></router-outlet>
<ng-container *ngIf="outlet?.activatedRouteData?.animation as animation">
  <div [@routeAnimations]="prepareRoute(outlet)" class="content">
  </div>
</ng-container>

<app-footer class="footer"></app-footer>